import React from "react";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT, UI_THEME } from "utils/constants/ui";
import { getIconForUID } from "components/FormerEditor/utils";
import classnames from "classnames";
import { attachmentSizeLabel } from "utils/attachment";

/**
 * Open the asset picker for image upload
 * @param {Object} params
 * @param {Function} params.onClick
 */
const UploadPrompt = ({ onClick, prompt, icon, maxSize }) => {
  const UploadIcon = getIconForUID(icon || "addImage");

  return (
    <div
      className="w-100 flex flex-column items-center justify-center tc pa3 bg-white--hover pointer ba br-6 hairline-1"
      onClick={onClick}
    >
      <UploadIcon size={28} />
      <div
        className={classnames("f5", {
          pv3: !maxSize,
          pt3: maxSize
        })}
      >
        {prompt.header}
      </div>
      {maxSize && (
        <div className="f7 pt2 pb3">{`${attachmentSizeLabel(
          maxSize
        )} max`}</div>
      )}
      <Button
        theme={UI_THEME.SLIM}
        classes={{
          contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
        }}
        onClick={onClick}
        copy="Upload"
      />
    </div>
  );
};

export default UploadPrompt;
